export default __webpack_public_path__ + "static/media/gallery36_2.d9347256.png";